type HairlineRuleProps = {
  animated?: boolean;
  color?: string;
};

export function HairlineRule({ animated = true, color = "var(--hairline-strong)" }: HairlineRuleProps) {
  return (
    <div style={{ width: "100%", height: 1, position: "relative", overflow: "hidden" }}>
      <div
        className="mfm-rule-fill"
        style={{
          position: "absolute",
          inset: 0,
          background: color,
          transformOrigin: "left center",
          animation: animated ? "mfmRuleDraw 900ms cubic-bezier(.22,1,.36,1) both" : "none",
        }}
      />
    </div>
  );
}
